<template lang="pug">
.card-inteligencia-territorial-restricoes-socioambientais
    .card-inteligencia-territorial-restricoes-socioambientais-interno--titulo {{ $t('mensagens.inteligenciaTerritorial.totalImoveisRestricao') }}:
    .card-inteligencia-territorial-restricoes-socioambientais-interno--valor(v-if='areaPlantadaRestricao') {{ formatoNumero(areaPlantadaRestricao) }} ha
    .card-inteligencia-territorial-restricoes-socioambientais-interno--valor(v-else) -
    .separador-personalizado
    .card-inteligencia-territorial-restricoes-socioambientais-interno--titulo(style='margin-bottom: 10px') {{ $t('mensagens.blocoAlerta.filtros.filtroCriteriosSocioambientais') }}:
    .grupo-restricoes
      .subgrupo-restricoes
        .subtitulo-informativo {{ $t('mensagens.monitoramentoSocioambiental.categorias.embargos') }}:
        .subvalores-informativos(v-if='embargos') {{ formatoNumero(embargos) }} ha
        .subvalores-informativos(v-else) -
      .subgrupo-restricoes
        .subtitulo-informativo {{ $t('mensagens.monitoramentoSocioambiental.categorias.desmatamentos') }}:
        .subvalores-informativos(v-if='desmatamento') {{ formatoNumero(desmatamento) }} ha
        .subvalores-informativos(v-else) -
    .grupo-restricoes
      .subgrupo-restricoes
        .subtitulo-informativo {{ $t('mensagens.monitoramentoSocioambiental.categorias.restricoesTerrasIndigenas') }}:
        .subvalores-informativos(v-if='restricoesIndigenas') {{ formatoNumero(restricoesIndigenas) }} ha
        .subvalores-informativos(v-else) -
      .subgrupo-restricoes
        .subtitulo-informativo {{ $t('mensagens.monitoramentoSocioambiental.categorias.restricoesUnidadesConservacao') }}:
        .subvalores-informativos(v-if='restricoesConservacao') {{ formatoNumero(restricoesConservacao) }} ha
        .subvalores-informativos(v-else) -
    .grupo-restricoes
      .subgrupo-restricoes
        .subtitulo-informativo {{ $t('mensagens.camadas.SITIOS_ARQUEOLOGICOS') }}:
        .subvalores-informativos(v-if='sitiosArqueologicos') {{ formatoNumero(sitiosArqueologicos) }}
        .subvalores-informativos(v-else) -
    .separador-personalizado(v-show='!restricoesSocioambientais')
    .card-inteligencia-territorial-restricoes-socioambientais-interno--titulo(v-show='!restricoesSocioambientais')
        span
            i.el-icon-warning-outline.tamanho-icone &nbsp;
        span {{ $t('mensagens.monitoramentoSocioambiental.naoHaRestricoesParaDemaisCriterios') }}
    .card-inteligencia-territorial-restricoes-socioambientais-interno--titulo
        span.color-inforacao.posicao-texto.abrindo-modal-cars(
            @click='abreModalInteligenciaTerritorialRestricoesSocioambientais'
        ) {{ $t('mensagens.inteligenciaTerritorial.verDetalhes') }}
            i.el-icon-right.color-inforacao

    ModalInteligenciaTerritorialRestricoesSocioambientais(
        v-if='abrirModalRestricoesSocioambientais',
        :abrirModalRestricoesSocioambientais='abrirModalRestricoesSocioambientais',
        :restricoesSocioambientais='restricoesSocioambientais',
        @fecharModalRestricoesSocioambientais='fecharModalRestricoesSocioambientais'
    )
</template>
<script>
import ModalInteligenciaTerritorialRestricoesSocioambientais from '@/components/inteligenciaTerritorial/ModalInteligenciaTerritorialRestricoesSocioambientais.vue';
import formatters from '@/utils/formatters';
export default {
    name: 'CardInteligenciaTerritorialRestricoesSocioambientais',
    components: {
        ModalInteligenciaTerritorialRestricoesSocioambientais
    },
    props: {
        restricoesSocioambientais: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            embargos: null,
            desmatamento: null,
            restricoesIndigenas: null,
            restricoesConservacao: null,
            areaPlantadaRestricao: null,
            sitiosArqueologicos: null,
            abrirModalRestricoesSocioambientais: false
        };
    },

    watch: {
        restricoesSocioambientais: function () {
            this.calcularRestricoes();
        }
    },

    methods: {
        fecharModalRestricoesSocioambientais() {
            this.abrirModalRestricoesSocioambientais = false;
        },

        formatoNumero(number) {
            return formatters.formatNumber(number, 0);
        },

      calcularRestricoes() {
        this.embargos = 0;
        this.desmatamento = 0;
        this.restricoesConservacao = 0;
        this.restricoesIndigenas = 0;
        this.areaPlantadaRestricao = 0;
        this.sitiosArqueologicos = 0;

        this.embargos +=
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoAmazoniaProtegeHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoEmbargosIbamaHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoLDIHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoEmbargosIcmbioHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoEmbargosSemasMTHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoMoratoriaSojaHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoEmbargosGOHa);

        this.desmatamento +=
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoDeterAmazoniaHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoDeterCerradoHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoMoratoriaSojaHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoProdesHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoProdesCerradoHa);

        this.restricoesConservacao +=
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoUnidadeConservacaoProtecaoIntegralHa) +
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoUnidadeConservacaoUsoSustentavelHa);

        this.restricoesIndigenas +=
            this.converterStringParaFloat(this.restricoesSocioambientais.areaSobreposicaoTerraIndigenaHa);

        this.areaPlantadaRestricao += this.converterStringParaFloat(this.restricoesSocioambientais.areaRestricaoHa);

        this.sitiosArqueologicos += this.converterStringParaFloat(this.restricoesSocioambientais.quantidadeSitiosArqueologicos);
      },

        abreModalInteligenciaTerritorialRestricoesSocioambientais() {
            this.abrirModalRestricoesSocioambientais = true;
        },
        converterStringParaFloat(valor) {
            if (valor === null || valor === '') {
                return 0;
            } else {
                return parseFloat(valor);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.card-inteligencia-territorial-restricoes-socioambientais {
    height: 450px;
    border-radius: 8px;
    background: var(--white);
    display: flex;
    flex-direction: column;
    padding: 15px 20px 36px;
    color: var(--primary);
    box-shadow: 0px 0px 10px 0px #0000001A;

    .grupo-restricoes {
        display: flex;
        justify-content: space-between;
        gap: 16px;
        margin: 0px 0 14px 00px;
    }
    .subgrupo-restricoes {
        display: flex;
        flex-grow: 1;
        flex-basis: 0%;
        flex-direction: column;
        padding: 3px 0;
    }
    .subtitulo-informativo {
        font-weight: 400;
    }
    .subvalores-informativos {
        color: var(--primary);
        font-size: 16px;
        font-weight: 600;
    }

    .card-inteligencia-territorial-restricoes-socioambientais-interno--titulo {
        font-size: 16px;
        font-weight: 400;
    }

    .card-inteligencia-territorial-restricoes-socioambientais-interno--valor {
        font-weight: 600;
        color: var(--primary);
        font-size: 26px;
    }
    .color-inforacao {
        cursor: pointer;
        color: var(--blue);
        i {
            font-size: 20px;
            margin-top: 2px;
        }
    }

    .tamanho-icone {
        font-size: 18px;
    }

    .posicao-texto {
        display: flex;
        justify-content: right;
        margin: 3.6rem 0 0 0 !important;
    }

    .separador-personalizado {
        border: 2px;
        width: 45px;
        margin-top: 25px;
        border-top: 2px solid var(--secondary-two);
        margin-left: 0px;
    }

    .abrindo-modal-cars {
        cursor: pointer;
    }

    & p:first-child {
        margin: 4px 3px 8px 0px;
    }

    & p:not(:first-child) {
        margin: 2px 3px 8px 0px;
    }
}
</style>
